import { Box, ColorOptions, IconNew, IconNewOptions, ModBox, TextNew } from '@jfs/ui-new'
import { useCallback, useState } from 'react'
import { styles } from './styles'
import { DropDownBoxInterface, DropdownTypes } from './types'

export const DropDownBox = ({
  showBorder,
  isIconAvailable,
  onLayout,
  toggleDropdown,
  iconType,
  defaultLabel,
  dropdownVisible,
  type,
  value,
  clearSelection,
  chevronColor,
  disabled,
  testID,
  textColor,
}: DropDownBoxInterface) => {
  const [layoutNativeEvent, setLayoutNativeEvent] = useState(null)
  const handlePress = () => {
    layoutNativeEvent?.target?.measureInWindow((x, y, width, height) => {
      onLayout && onLayout({ top: y + height, left: x, width })
      toggleDropdown(true)
    })
  }

  const onBoxLayout = useCallback(({ nativeEvent }) => {
    setLayoutNativeEvent(nativeEvent)
  }, [])

  const showHighlight = type === DropdownTypes.SELECTABLE_HIGHLIGHT && value?.length > 0
  const borderColor = 'DISABLED_GREY'
  const bgColor =
    type === DropdownTypes.DEFAULT_WITH_BG
      ? ('#0186B014' as ColorOptions)
      : disabled
      ? ('GRAY_HALF' as ColorOptions)
      : 'WHITE'
  const boxHeight =
    type === DropdownTypes.DEFAULT_WITH_BG ? 20 : type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 36 : 35
  const textLabelColor =
    textColor !== undefined ? textColor : type === DropdownTypes.DEFAULT_WITH_BG ? 'BLUE' : 'BLACK_21'
  return (
    <Box onLayout={onBoxLayout as any}>
      <ModBox show={!showHighlight} {...styles.overlayStyle} onPress={handlePress} disabled={disabled} />
      <Box
        {...styles.dropdownBox(showBorder, isIconAvailable, borderColor, boxHeight, bgColor, type)}
        onPress={handlePress}
        testID={testID}>
        <ModBox show={iconType !== null} {...styles.iconContainer}>
          <IconNew hide={iconType === null} id={iconType as IconNewOptions} size={16} color="BLACK_21" />
        </ModBox>
        <ModBox
          show={defaultLabel !== (null || '')}
          {...styles.labelContainer}
          flex={1}
          pl={type === DropdownTypes.DEFAULT_WITH_BG ? 8 : 15}>
          <TextNew {...styles.label} color={disabled ? 'BLACK_LIGHT' : textLabelColor} numberOfLines={1}>
            {defaultLabel}
          </TextNew>
        </ModBox>
        <Box {...styles.dropdownIconContainer} onPress={() => showHighlight && clearSelection()}>
          <IconNew
            id={dropdownVisible ? 'ARROW_UP' : showHighlight ? 'CLEAR' : 'ARROW_DOWN'}
            size={16}
            color={disabled ? 'BLACK_LIGHT' : chevronColor ?? 'BLACK_21'}
          />
        </Box>
      </Box>
    </Box>
  )
}
